// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import Voucher from './Voucher'
import { actions } from 'features/Cart'

const mapStateToProps = ({ participant, cart }, ownProps) => ({
  email: participant.email,
  customer: cart.customer
})

const mapDispatchToProps = dispatch => ({
  fetchCart: () => dispatch(actions.loadCart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Voucher)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Voucher/VoucherContainer.js